/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { App } from 'app/App'
import { useAuth } from 'app/pages/module/auth/core/Auth'
import SigninPage from 'app/pages/module/auth/Login1'
import ErrorsPage from 'app/pages/module/errors/ErrorsPage'
import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { OnboardingGuard } from './OnboardingGuard'
import CreateCustomer from 'app/pages/customer/CreateCustomer'
import RegisterCleaner from 'app/pages/cleaner/RegisterCleaner'
import {VerifyOTP} from 'app/pages/module/auth/VerifyOTP'
import RegisterCompany from 'app/pages/company/RegisterCompany1'
import JobList from 'app/pages/jobs/JobList'
import JobDetails from 'app/pages/jobs/JobDetails'
import  Companies from 'app/pages/company-display/Companies'
import CompanyDetails from 'app/pages/company-display/CompanyDetails'
import MapDisplay from 'app/pages/map-display/MapDisplay'
import { RegisterAsIndividual } from 'app/pages/individual/account/RegisterAsIndividual'
import { ForgetPassword } from 'app/pages/module/auth/ForgetPassword'
import { ResetPassword } from 'app/pages/module/ResetPassword'
import { LayoutSplashScreen } from 'sr/layout/master-layout'
import { RegisterasSupervisor } from 'app/pages/supervisor/RegisterasSupervisor'
import { SearchJob } from 'app/pages/jobs/SearchJob'
import { ScrollTop } from 'sr/layout/components/ScrollTop'
import { HireCleaner } from 'app/pages/module/auth/HireCleaner'
import { DeclineContractor } from 'app/pages/cleaner/DeclineContractor'
import RegisterCorporate from 'app/pages/corporate/components/RegisterCorporate'
import RegisterOptions from 'app/pages/module/auth/RegisterOptions'
import Impersonate from 'app/pages/module/auth/Impersonate'

const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  //const { currentUser } = useAuth()
  const currentUser = false;
  const {isAuthenticate, isAuthReady, logout, userType} = useAuth()
  if (!isAuthReady) {
    return <LayoutSplashScreen />
  }
  
  return (
    // <CreditCardProvider>
    <BrowserRouter basename={PUBLIC_URL}>
      <ScrollTop />
      <Routes>
        <Route element={<App />}>
          {/* <Route path='/*' element={<ErrorsPage />} /> */}
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='/auth/impersonate' element={<Impersonate />} />
          {/* <Route path='logout' eleme--nt={<Logout />} /> */}
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
              <Route index element={<Navigate to='/reports' />} />
            </>
          ) : (
            //   <>
            //     <Route path='*' element={<Navigate to='/homed' />} />
            //     <Route path='auth/*' element={<AuthPage />} />
            //     <Route path='/createcompany' element={<CreateCompany />} />
            //     <Route path='/createcustomer' element={<CreateCustomer />} />
            //     <Route path='/createcleaner' element={<CreateCleaner />} />
            //     <Route path='/createjob' element={<CreateJob />} />
            //     <Route path='/jobs' element={<Jobs />} />
            //     <Route path='homed/*' element={<DummyHome />} />
            //   </>
            // )}
            <>
            <Route path='/contractor/decline/:id' element={<DeclineContractor />}></Route>
            <Route path='/hire' element={<HireCleaner />} />
              <Route path='/verify-otp' element={<VerifyOTP />} />
              <Route path='/cleaner-jobs' element={<JobList />} />
              <Route path='/job-detail/:id' element={<JobDetails />} />
                            <Route path='/create-cleaner' element={<RegisterCleaner />} />

              <Route path='/companies' element={<Companies />} />
              <Route path='/company-details/:id' element={<CompanyDetails />} />
             <Route path='/search/:query' element={<SearchJob />} />
              <Route path='/map' element={<MapDisplay />} />
                           <Route path='/create-company' element={<RegisterCompany />} />
              <Route path='/create-cleaner/:id' element={<RegisterCleaner />} />
              <Route path='create-supervisor/:id' element={<RegisterasSupervisor />} />
              <Route path='/create-customer' element={<CreateCustomer />} />
              <Route path='/register' element={<RegisterOptions />} />

              <Route path='/registerasindividual' element={<RegisterAsIndividual />} />

              <Route path='/' element={<Navigate to='/auth' />} />
            {isAuthenticate && (
              <Route element={<OnboardingGuard />}>
                <Route path='/*' element={<PrivateRoutes />} />
              </Route>
            )}
            {!isAuthenticate && <>
           <Route path='*' element={<Navigate to='/auth' />} />
              <Route index element={<Navigate to='/reports' />} />
              <Route path='/auth' element={<SigninPage />} />
              <Route path='/create-company' element={<RegisterCompany />} />
              <Route path='/create-customer' element={<CreateCustomer />} />
              <Route path='/create-cleaner' element={<RegisterCleaner />} />
              <Route path='/register' element={<RegisterOptions />} />
              <Route path='/corporate-signup' element={<RegisterCorporate />} />
              <Route path='/create-cleaner/:id' element={<RegisterCleaner />} />
              <Route path='create-supervisor/:id' element={<RegisterasSupervisor />} />
              <Route path='/forget-password' element={<ForgetPassword />} />
              <Route path='/reset-password' element={<ResetPassword />} />
              <Route path='/reset-password/:session' element={<ResetPassword />} />
            </>
          }
        </> 
          )}
        </Route>
        
      </Routes>
    </BrowserRouter>
    // </CreditCardProvider>
  )
}

export { AppRoutes }
